import { defineMessages } from 'react-intl'

export const dropZoneModalMessages = defineMessages({
  errorMessage: {
    id: 'dropZoneModalMessages.dropZoneModalErrorMessage',
    description: "Drag 'n' drop error message in dropZone Modal",
    defaultMessage:
      'Invalid File{br} supported formats: {br}{accept}, and maximum file size: {maxSize}',
  },
  cancelLabel: {
    id: 'dropZoneModalMessages.dropZoneModalCancelLabel',
    description: 'Cancel label in dropZone Modal',
    defaultMessage: 'Cancel',
  },
})
